var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBanistmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 20,
    viewBox: "0 0 128 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10174 13.956C11.7889 13.9562 14.2385 15.7734 14.9338 18.5054L9.09759 20L7.60751 14.1454C8.10737 14.0175 8.60845 13.9561 9.10174 13.956Z",
    fill: "url(#paint0_linear_4176_6282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09042 9.31954C6.86912 12.1398 6.03206 15.8725 3.22086 17.6567L0 12.5503L5.09042 9.31954Z",
    fill: "url(#paint1_linear_4176_6282)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9656 7.5802C19.0954 7.5802 19.2266 7.58451 19.358 7.59304L18.9716 13.6229L12.9604 13.2355C13.1655 10.037 15.8152 7.58022 18.9656 7.5802Z",
    fill: "url(#paint2_linear_4176_6282)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9768 2.23198L13.7516 7.84717C10.6604 6.61427 9.1505 3.10106 10.3793 0L15.9768 2.23198Z",
    fill: "url(#paint3_linear_4176_6282)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88786 5.4272C6.7638 7.9955 2.96608 8.35033 0.405787 6.21962L4.25185 1.56905L8.88786 5.4272Z",
    fill: "url(#paint4_linear_4176_6282)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1656 3.23455H31.6201C32.738 3.23455 33.6382 3.5346 34.3209 4.13434C35.0032 4.73426 35.3446 5.52988 35.3446 6.52067C35.3446 7.27719 35.1364 7.92919 34.7207 8.47685C34.3045 9.02468 33.7715 9.40294 33.1217 9.61127V9.68966C33.9143 9.87239 34.5449 10.2505 35.0132 10.8243C35.481 11.3982 35.715 12.1544 35.715 13.0933C35.715 14.2933 35.3412 15.1863 34.594 15.7731C33.8462 16.36 32.855 16.6535 31.6201 16.6535H25.1656V3.23455ZM31.2496 8.96585C31.9127 8.96585 32.4455 8.77369 32.8484 8.38886C33.2514 8.00438 33.453 7.50542 33.453 6.89235C33.453 6.2144 33.2709 5.70585 32.9069 5.3667C32.543 5.02755 32.0425 4.85797 31.4055 4.85797H27.018V8.96585H31.2496ZM31.5811 15.0299C33.0758 15.0299 33.8236 14.3061 33.8236 12.8586C33.8236 11.346 33.0304 10.5894 31.4443 10.5894H27.018V15.0299H31.5811Z",
    fill: "#004F7B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5829 3.23455H44.9423L50.1294 16.6535H48.16L46.8145 13.0739H40.6135L39.3067 16.6535H37.3958L42.5829 3.23455ZM46.2099 11.4501L44.6497 7.26404L43.7529 4.83842H43.6555L42.7778 7.22493L41.2178 11.4501H46.2099Z",
    fill: "#004F7B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5724 3.23455H54.23L61.289 12.5847L61.7572 13.2108L61.835 13.1912V3.23455H63.5704V16.6535H61.9911L54.8929 7.18583L54.386 6.5013L54.308 6.52085V16.6535H52.5724V3.23455Z",
    fill: "#004F7B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4007 3.23455H67.5485V16.6535H69.4007V3.23455Z",
    fill: "#004F7B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1726 15.9101C73.1454 15.2583 72.6319 14.241 72.6319 12.8586L72.6514 12.4674H74.4845C74.4845 12.4806 74.4778 12.5261 74.4652 12.6043C74.4519 12.6825 74.4457 12.774 74.4457 12.8782C74.4457 13.6738 74.7737 14.2769 75.4304 14.6875C76.0865 15.0983 76.961 15.3038 78.0531 15.3038C79.2747 15.3038 80.211 15.1115 80.8609 14.7266C81.5109 14.3422 81.836 13.7911 81.836 13.0739C81.836 12.5915 81.667 12.1905 81.3289 11.8709C80.9908 11.5514 80.565 11.3005 80.0517 11.1177C79.5381 10.9352 78.846 10.7331 77.9749 10.5112C76.8958 10.2375 76.0249 9.97335 75.362 9.71898C74.6991 9.46462 74.1337 9.08672 73.6655 8.58457C73.1973 8.08259 72.9634 7.42064 72.9634 6.59906C72.9634 5.42536 73.4509 4.53215 74.426 3.91908C75.4008 3.30636 76.649 2.99974 78.17 2.99974C79.6911 2.99974 80.9259 3.30956 81.875 3.92886C82.8237 4.5485 83.2984 5.49717 83.2984 6.77504V7.00985H81.4852V6.71638C81.4852 6.05123 81.1825 5.52988 80.5783 5.15144C79.9739 4.77336 79.1905 4.58423 78.2283 4.58423C77.2015 4.58423 76.3791 4.74065 75.7617 5.05368C75.1442 5.3667 74.8354 5.83615 74.8354 6.46201C74.8354 6.91884 75.0012 7.29034 75.3327 7.57706C75.6643 7.86413 76.0738 8.09539 76.5614 8.27136C77.0487 8.44752 77.7279 8.6466 78.599 8.86808C79.678 9.142 80.5588 9.40934 81.2412 9.6701C81.9239 9.93122 82.5019 10.3125 82.9768 10.8145C83.4512 11.3166 83.6884 11.972 83.6884 12.7804C83.6884 14.2151 83.1912 15.2583 82.1968 15.9101C81.2022 16.5625 79.8532 16.8883 78.1505 16.8883C76.5253 16.8883 75.1993 16.5625 74.1726 15.9101Z",
    fill: "#004F7B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89.2848 4.85815H84.6827V3.23455H95.7394V4.85815H91.1374V16.6535H89.2848V4.85815Z",
    fill: "#004F7B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3249 3.23455H101.074L104.272 12.3892C104.389 12.7283 104.51 13.1164 104.633 13.5531C104.757 13.99 104.838 14.2737 104.877 14.404H104.955C104.994 14.2608 105.075 13.9609 105.199 13.5041C105.322 13.0479 105.436 12.6761 105.54 12.3892L108.757 3.23455H111.487V16.6535H109.635V7.79232L109.674 5.28849H109.538C109.524 5.37985 109.485 5.56578 109.42 5.84592C109.355 6.1266 109.284 6.37101 109.206 6.57951L105.579 16.6535H104.038L100.47 6.57951C100.405 6.39696 100.336 6.15895 100.265 5.86548C100.193 5.57218 100.151 5.37985 100.138 5.28849H100.021L100.061 7.79232V16.6535H98.3249V3.23455Z",
    fill: "#004F7B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.388 15.1374C115.224 13.9707 114.643 12.2393 114.643 9.94402C114.643 7.6487 115.224 5.91774 116.388 4.75043C117.552 3.58313 119.192 2.99974 121.312 2.99974C123.443 2.99974 125.091 3.58366 126.255 4.75043C127.418 5.91774 128 7.64887 128 9.94402C128 12.2262 127.418 13.9541 126.255 15.1278C125.091 16.3014 123.443 16.8883 121.312 16.8883C119.192 16.8883 117.551 16.3047 116.388 15.1374ZM124.86 14.0421C125.68 13.201 126.089 11.8611 126.089 10.0222V9.94402C126.076 8.07921 125.66 6.71976 124.841 5.86548C124.022 5.01155 122.845 4.58423 121.312 4.58423C119.79 4.58423 118.621 5.01155 117.801 5.86548C116.982 6.71976 116.566 8.07921 116.554 9.94402V10.0222C116.554 11.8611 116.963 13.201 117.782 14.0421C118.601 14.8832 119.777 15.3038 121.312 15.3038C122.858 15.3038 124.041 14.8832 124.86 14.0421Z",
    fill: "#004F7B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4176_6282",
    x1: 2.44476,
    y1: 17.138,
    x2: 16.5552,
    y2: 3.07158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EF233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF233C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4176_6282",
    x1: 2.44476,
    y1: 17.138,
    x2: 16.5552,
    y2: 3.07158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EF233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF233C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4176_6282",
    x1: 2.44476,
    y1: 17.138,
    x2: 16.5552,
    y2: 3.07158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EF233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF233C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4176_6282",
    x1: 2.44476,
    y1: 17.138,
    x2: 16.5552,
    y2: 3.07158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EF233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF233C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4176_6282",
    x1: 2.44476,
    y1: 17.138,
    x2: 16.5552,
    y2: 3.07158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#004F7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EF233C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF233C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBanistmo);
export default __webpack_public_path__ + "static/media/logo_banistmo.72a2fd0a4c2b4edda8514d11d557fbc7.svg";
export { ForwardRef as ReactComponent };